import React from 'react';
import { Tab } from 'rbx';

const ContextMenu = ({ onClick }) => {
  console.log();
  return (
    <>
      <Tab onClick={onClick} style={{ minWidth: '180px' }}>
        <span className="icon">
          <div style={{ display: 'flex', gap: '2px', alignItems: 'center' }}>
            <div
              style={{
                width: '4px',
                height: '4px',
                backgroundColor: '#363636',
                borderRadius: '50%',
              }}
            />

            <div
              style={{
                width: '4px',
                height: '4px',
                backgroundColor: '#363636',
                borderRadius: '50%',
              }}
            />
            <div
              style={{
                width: '4px',
                height: '4px',
                backgroundColor: '#363636',
                borderRadius: '50%',
              }}
            />
          </div>
        </span>
      </Tab>
    </>
  );
};

export default ContextMenu;
